export default __webpack_public_path__ + "static/media/payment-detail.b11ce574.svg";